"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItem = void 0;
const CartItemImage_1 = require("./CartItemImage");
const CartItemPrice_1 = require("./CartItemPrice");
/**
 * A representation of the items data for visualisation
 */
class CartItem {
    /**
     * Creates a new instance from raw data
     * @param {IItemContent} rawData
     */
    constructor(rawData) {
        this.images = rawData.images.map((img) => new CartItemImage_1.CartItemImage(img));
        this.isActive = rawData.isActive;
        this.itemClassId = rawData.itemClassId;
        this.itemId = rawData.itemId;
        this.manufacturer = rawData.manufacturer;
        this.registrationNumber = rawData.registrationNumber;
        this.prices = rawData.prices.map((price) => new CartItemPrice_1.CartItemPrice(price));
        this.title = rawData.title;
        this.url = rawData.url;
        this.daysSincePublishing = rawData.daysSincePublishing;
        this.itemRank = rawData.itemRank;
        this.ratingAverage = rawData.ratingAverage;
        this.attributes = rawData.attributes;
    }
}
exports.CartItem = CartItem;
